const inputs = {
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'roleList.form.name.label',
    placeholder: 'roleList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textField',
    label: 'roleList.form.description.label',
  },
  project: {
    id: 'proyect_id',
    name: 'project',
    input: 'select',
    label: 'roleList.form.project.label',
    helpertext: 'roleList.form.project.helperText',
  },
  permissions: {
    id: 'permissions',
    type: 'array',
    name: 'permissions',
  }
}

export default inputs;